import TagSelect from '../Tags/TagSelect';
import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import Loading from '../Loading';
import { groupAuthors } from '../../utils/developers';
import Dropdown from '../Dropdown';
import DeleteIcon from '@mui/icons-material/Delete';
import { sendRequest } from '../../utils/dateHelpers';

function CustomGroupingEmail({
  triggerGetData,
  data,
  tagData,
  buttonClassName,
  buttonLabel = 'Custom Grouping'
}) {
  const [loading, setLoading] = useState(false);
  const [suggestion, setSuggestion] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [findGrouping, setFindGrouping] = useState(null);
  const [groupedData, setGroupedData] = useState({});
  const [allEmails, setAllEmails] = useState([]);
  const [emailOptionsDropdown, setEmailOptionsDropdown] = useState([]);

  const handleClear = () => {
    setEmailOptionsDropdown([]);
    setGroupedData({});
    setAllEmails([]);
    setFindGrouping(null);
  };

  const handleUpdateClick = async formData => {
    try {
      setLoading(true);
      const response = await sendRequest('/developers/email-bindings', 'POST', {
        emailAuthorsMappings: formData
      });

      if (response.success) {
        toast.success('Successfully added!');
        triggerGetData();
        setLoading(false);
        handleClear();
      }
    } catch (error) {
      console.error('Error adding email:', error);
      setLoading(false);
    }
  };

  const handleNewRow = () => {
    const newRowRecord = [];
    newRowRecord['newrow-' + Math.random()] = {
      authorName: '',
      emailOptions: []
    };

    setFindGrouping(prev => {
      const newData = { ...prev, ...newRowRecord };
      return newData;
    });

    setGroupedData(prev => {
      const newData = { ...prev, ...newRowRecord };
      return newData;
    });
  };

  const handleUseTempData = () => {
    if (!groupedData || !Object.keys(groupedData).length) {
      toast.error(
        'Please select at least one email column and a author column!'
      );
      return;
    }

    const findEmail = Object.keys(groupedData).map(authorNamex => {
      const { authorName, emailOptions, tags } = groupedData[authorNamex];

      const tagsUid =
        tags && tags.length > 0
          ? Object.values(tags).map(tag => tag.value)
          : null;

      const emails = emailOptions.map(({ value }) => {
        return value;
      });

      return {
        emails: [...emails],
        author: authorName,
        tags: tagsUid
      };
    });

    const assignsAiAgent = Object.values(groupedData).some(({ tags }) =>
      (tags || []).some(
        tag =>
          String(tag?.label || '')
            .trim()
            .toLowerCase() === 'ai agent'
      )
    );
    if (assignsAiAgent) {
      toast.error(
        'AI Agent can only be assigned from the developer edit screen.'
      );
      return;
    }

    handleUpdateClick(findEmail);
  };

  useEffect(() => {
    if (groupedData) {
      const findEmail = Object.keys(groupedData).map(authorName => {
        const emailOptionsTemp = groupedData[authorName].emailOptions;

        return emailOptionsTemp.map(({ value }) => {
          return value;
        });
      });
      const uniqueNested = [...new Set(findEmail.flat())];

      const diff1 = allEmails.filter(x => !uniqueNested.includes(x));

      setEmailOptionsDropdown(diff1);
    }
  }, [groupedData]);

  useEffect(() => {
    const emailsNested2 = data.map(a => a.author_email);
    const allEmailList = [...new Set(emailsNested2.flat())];

    setAllEmails(allEmailList);

    const allGroupedData = groupAuthors(data);

    const multiMemberGroupsWithValues = {};
    Object.entries(allGroupedData).forEach(([groupName, groupItems]) => {
      if (groupItems.length > 1) {
        const emailsNested = groupItems.map(a => a.author_email);
        const uniqueNested = [...new Set(emailsNested.flat())];

        const emailOptions = uniqueNested.map(email => ({
          label: email,
          value: email
        }));

        multiMemberGroupsWithValues[groupName + Math.random()] = {
          emailOptions,
          authorName: groupName,
          org: groupItems
        };
      }
    });

    setSuggestion(!!Object.keys(multiMemberGroupsWithValues).length > 0);
    setGroupedData(multiMemberGroupsWithValues);
    setFindGrouping(multiMemberGroupsWithValues);
  }, [data]);

  const onInputChange = (oldName, newName) => {
    setGroupedData(prev => {
      const updated = { ...prev };
      updated[oldName].authorName = newName;

      return updated;
    });
  };

  const onDropdownChange = (authorName, selectedEmails, name) => {
    setGroupedData(prev => ({
      ...prev,
      [authorName]: {
        ...prev[authorName],
        [name]: selectedEmails
      }
    }));
  };

  const onRemove = authorName => {
    setFindGrouping(prev => {
      const newData = { ...prev };
      delete newData[authorName];
      return newData;
    });
  };

  console.log('___tagData', tagData);

  return (
    <>
      {modalOpen && (
        <Modal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          title="Grouping Email"
        >
          <div className="space-y-6 " style={{ minHeight: '400px' }}>
            {loading ? (
              <Loading type="csv" />
            ) : (
              <>
                <div className="flex gap-2">
                  <div className="flex flex-col gap-4 pt-2">
                    {suggestion && (
                      <div className="mb-4">
                        <h2 className="text-lg font-semibold text-blue-600 border-b border-blue-300 pb-1">
                          🔍 Suggestions
                        </h2>
                      </div>
                    )}
                    {findGrouping &&
                      Object.keys(findGrouping).map(authorName => {
                        return (
                          <div key={authorName} className="flex flex-row gap-2">
                            <div>
                              <button
                                onClick={() => onRemove(authorName)}
                                className="text-red-500 hover:text-red-700"
                                aria-label={`Remove ${authorName}`}
                                title={`Remove ${authorName}`}
                              >
                                <DeleteIcon />
                              </button>
                            </div>
                            <div>
                              <div className="select-container">
                                <label className="select-label capitalize dark:border-strokedark dark:bg-meta-4 dark:text-white dark:focus:border-primary">
                                  Author Name
                                </label>
                                <input
                                  value={groupedData[authorName].authorName}
                                  onChange={e =>
                                    onInputChange(authorName, e.target.value)
                                  }
                                  className="border border-gray-300 rounded px-2 py-1 text-sm h-9"
                                />
                              </div>
                            </div>
                            <div>
                              <Dropdown
                                options={[
                                  ...findGrouping[authorName].emailOptions,
                                  ...emailOptionsDropdown.map(email => ({
                                    label: email,
                                    value: email
                                  }))
                                ]}
                                isMulti={true}
                                selectedValue={
                                  groupedData[authorName]?.emailOptions
                                }
                                label={'Emails'}
                                widthClassName="min-w-96"
                                onChange={e =>
                                  onDropdownChange(
                                    authorName,
                                    e,
                                    'emailOptions'
                                  )
                                }
                              />
                            </div>
                            <div>
                              <TagSelect
                                options={Object.entries(tagData).map(
                                  ([value, label]) => ({
                                    value,
                                    label
                                  })
                                )}
                                isMulti={true}
                                selectedValue={groupedData[authorName]?.tags}
                                label="Tags"
                                inputId={`email-tags-${authorName}`}
                                aria-label="Tags"
                                widthClassName="min-w-44"
                                onChange={e =>
                                  onDropdownChange(authorName, e, 'tags')
                                }
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="flex justify-between mt-4">
                  <div className="flex gap-4">
                    {findGrouping && Object.keys(findGrouping).length > 0 && (
                      <button
                        onClick={handleUseTempData}
                        className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                      >
                        Save
                      </button>
                    )}

                    <button
                      onClick={handleNewRow}
                      className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                    >
                      +
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal>
      )}
      <button
        onClick={() => setModalOpen(true)}
        className={
          buttonClassName ||
          'mb-2 rounded bg-blue-400 px-2 py-1 text-sm text-white transition hover:bg-blue-700'
        }
        type="button"
      >
        {buttonLabel}
      </button>
    </>
  );
}

CustomGroupingEmail.propTypes = {
  triggerGetData: PropTypes.func.isRequired,
  data: PropTypes.array,
  tagData: PropTypes.object,
  buttonClassName: PropTypes.string,
  buttonLabel: PropTypes.string
};

export default CustomGroupingEmail;
